import { create } from 'zustand';
import { persist, createJSONStorage, devtools } from 'zustand/middleware'
import { fetchPath } from '../config/defPath';
import type {
  SessionState,
  ModalState,
  AlertState,
} from '../config/types';
import type { Premio } from '../config/types/rankingApi';

declare global {
  interface Window {
    drupalSettings: any
  }
}

export const useModal = create<ModalState>(set => ({
  isOpen: false,
  modal: null,
  openModal: (componentName: string) =>
    set(state => ({ modal: componentName, isOpen: true })),
  closeModal: () => set({ isOpen: false }),
}));

export const useVideoPopup = create(set => ({
  isOpen: true,
  closeVideoPopup: () => set({ isOpen: false }),
}));

export const useAlert = create<AlertState>(set => ({
  dataAlert: null,
  setAlert: detail => set(state => ({ dataAlert: detail })),
  closeAlert: () => set({ dataAlert: false }),
}));

export const useSession = create<SessionState>()(
  devtools(
  persist((set, get) => ({
  logged: false,
  coins: 0,
  points: 0,
  user: {
    uid : '0',
    list_articles: [],
    name: 'Luis',
    lastname: 'Diaz',
    coins: '165',
    total_questions : '0',
    collectables: 'c03',
    json_avatar: {       
      genero: 'Hombre',
      piel: 'B',
      cabello: {type: '03', color: '002D6E' },
      barba: {type: '02', color: '000000' },
      Sup: {type: 'camiseta', code: '01'},
      Inf: {type: 'pant-corta', code: '01'},
      medias: {code: '01'},
      Cal: {type: 'guayos', code: '01'},
      Acc: [
          {type: 'guantes', code: '01'},
          {type: 'gafas-01'}
      ],
    },
  },
  updateCoins: points => set(state => ({ coins: points })),
  updatePoints: points => set(state => ({ points })),
  updateRedeemables: (item: string) => set(state => ({ user: {...state.user, list_articles: [...state.user.list_articles, item ] } })),
  updateAvatar: (jsonTemp: any) => set(state => ({ user: {...state.user, json_avatar: jsonTemp}})),
  validateSession: async (param) => {
    try {
      const dataUser = JSON.parse(sessionStorage.getItem('user-estadio'))
      
      if (!dataUser.state.logged || location.pathname === '/estadio-aguila/camerino') {
        const res = await fetch(`${fetchPath}/aguila/loyalty/validate/session`, { method: 'POST' });
        const data = await res.json();
        console.log('endpoint session', res)
        let updateData = {
          ...data.response,
          json_avatar: JSON.parse(data.response.json_avatar.replace(/(\r\n|\n|\r)/gm, "")),
          list_articles: data.response.list_articles ? [...data.response.list_articles] : [],
          total_questions: data.response.total_questions,
          collectables: data.response.collectables
        }
        
        if (data.message === 'Usuario autenticado.') {

          set(state => ({
            logged: true,
            user: updateData,
            coins: parseInt(data.response.coins),
            points: parseInt(data.response.points),
            listArticles: data.response.list_articles,
          }));
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  },
  resetState: () => set({ 
    logged: false, 
    coins: 0, 
    points: 0, 
    user: {
      uid : '0',
      list_articles: [],
      name: 'Luis',
      lastname: 'Diaz',
      coins: '165',
      json_avatar: null
    }
  }),

  closeSession: async () => { 
    try {
      const res = await fetch(
        `${fetchPath}/aguila/loyalty/session/close`,
        {
          method: 'POST',
        }
      );
      // console.log(res);

      if(res.ok) {
        sessionStorage.removeItem('user-estadio');
        sessionStorage.removeItem('btnStartClicked');
        sessionStorage.removeItem('tempGender');
        sessionStorage.removeItem('watchedvideo');
        location.reload();
        window.location.href = "/estadio-aguila"
      } 
    } catch (error) {
      console.log(error.message);
    }
  },
}), { name: 'user-estadio', storage: createJSONStorage(() => sessionStorage) }))
);

interface PropsCamerino {
  category: string;
  setCategory: (cat: string) => void;
}

export const useCamerino = create<PropsCamerino>(set => ({
  category: '',
  setCategory: (cat: string) => set(state => ({ category: cat })),
}));

export const useColor = create<{ color: string, setColor: (color: string) => void }>(set => ({
  color: '',
  setColor: (color: string) => set(state => ({ color })),
}));

interface RankingState {
  award: undefined | Premio
  setAward: (award: Premio | undefined) => void
}
export const useRanking = create<RankingState>(set => ({
  award: undefined,
  setAward: (award) => set(() => ({ award })),
}));